import React from 'react';
import PropTypes from 'prop-types';

import { DataGrid, PageTitleWithToolTip } from '../../Common';
import { text_commonCellProps } from '../../Common/DataGrid/utils';

import { TranslateW } from '../../../Utils/Languages/Translate';
import Routes from '../../../routes';
import { CardHeader } from '@mui/material';
import { isDesktop } from '../../../utils';

const columns = [
    {
        field: 'movementDate',
        headerName: 'Date',
        ...text_commonCellProps,
        renderCell: ({ row: { movementDate } }) => <span>{new Date(movementDate).toLocaleDateString()}</span>
    },
    {
        field: 'movementType',
        headerName: 'Movement Type',
        ...text_commonCellProps
    },
    {
        field: 'fromLocation',
        headerName: 'From Location',
        ...text_commonCellProps
    },
    {
        field: 'toLocation',
        headerName: 'To Location',
        ...text_commonCellProps
    },
    {
        field: 'recordedBy',
        headerName: 'Recorded By',
        ...text_commonCellProps
    }
]

const AssetMovementTable = ({
    assetID,
}) => {
    return (
        <>
            <DataGrid
                url={Routes.Asset.GetAssetMovement(assetID)}
                exportButtonURL={Routes.Asset.GetAssetMovementExport(assetID)}
                exportButtonAlt={"Export asset movement (.csv)"}
                headerContent={
                    isDesktop && (
                        <CardHeader
                            title={
                                <PageTitleWithToolTip
                                    pageTitle={TranslateW("assetMovementList.movement-history")}
                                />
                            }
                            sx={{
                                "& .MuiCardHeader-action": { display: "flex" },
                                "& .MuiCardHeader-content": { maxWidth: "100%", textWrap: "nowrap" }
                            }}
                        />
                    )
                }
                noResultText="Oops...It is empty here..."
                noResultText2="Create a new Asset Movement or change your search criteria."
                columns={columns}
            />
        </>
    )
}

AssetMovementTable.propTypes = {
    assetID: PropTypes.string.isRequired,
};

export default AssetMovementTable;
